<template>
  <div
    v-if="offlineSizings && offlineSizings?.sizings.length > 0"
    class="mb-5"
    data-cy="offline-sizings-container"
  >
    <h2 data-cy="offline-sizings-header">Unsaved Offline Sizings</h2>
    <data-table
      data-cy="offline-sizings-table"
      :value="offlineSizings.sizings || []"
      :rows-per-page-options="[5, 10, 20, 100]"
      paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      responsive-layout="scroll"
      current-page-report-template="Showing {first} to {last} of {totalRecords}"
    >
      <template #empty>
        <p class="text-center m-5" data-cy="no-sizings-found">
          No sizings found.
        </p>
      </template>
      <column field="title" header="Name" :sortable="true">
        <template #body="{ data }">
          <router-link
            :to="{ name: 'Sizing', params: { sizingId: data.id } }"
            data-cy="sizing-name-link"
          >
            {{ data.title || "Untitled" }}
          </router-link>
        </template>
      </column>
      <column
        v-if="$route.name !== 'Well'"
        field="well.well_name"
        header="Well"
        :sortable="true"
      >
        <template #body="{ data }">
          <router-link
            v-if="data.well?.id"
            :to="{
              name: 'Well',
              params: { well: data.well.id }
            }"
          >
            {{ data.well.well_name }}
          </router-link>
        </template>
      </column>
      <column
        field="customer.customer_name"
        header="Customer"
        :sortable="true"
      />
      <column
        v-if="$route.name !== 'Home'"
        field="author.display_name"
        header="Owner"
        :sortable="true"
      />
      <column field="parent_sizing" header="Parent Sizing">
        <template #body="{ data }">
          <router-link
            v-if="
              data.parent_sizing?.id && !data.parent_sizing?.journal_deleted_at
            "
            :to="{
              name: 'Sizing',
              params: { sizingId: data.parent_sizing?.id }
            }"
            >{{ data.parent_sizing.title }}
          </router-link>
          <div
            v-else-if="
              data.parent_sizing?.id && data.parent_sizing?.journal_deleted_at
            "
          >
            <i>{{ data.parent_sizing?.title }}</i> (deleted)
          </div>
        </template>
      </column>
      <column field="journal_updated_at" header="Last Updated" :sortable="true">
        <template #body="{ data }">
          {{ new Date(data.journal_updated_at).toLocaleDateString() }}
        </template>
      </column>
    </data-table>
  </div>
</template>

<script setup lang="ts">
import { useSizingsWithScenarioIdsQuery } from "gql/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

// Fetch offline sizings
const { data: offlineSizings } = useSizingsWithScenarioIdsQuery({
  variables: {
    withAggregate: false,
    where: {
      title: { _eq: "_offline_" }
    }
  }
});
</script>
